// import Grid from "@mui/material/Grid/Grid";
import CloverleafImage from "./image/Cloverleaf.png";
import LoginButtonImage from "./image/LoginButton.png";
import Box from '@mui/material/Box';
import { useNavigate } from "react-router-dom";
import { useMediaQuery } from "@material-ui/core";
import { Typography } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import { observer } from 'mobx-react';




// import { useEffect } from "react";
import { useStore } from "../../state/MobxContext";
import { Button, Grid } from "@mui/material";
//icon
import { faArrowRightFromBracket } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { StringFormat } from "../../utils/SessionService";





function TopBar() {
    const { loginStore } = useStore();
    const navigate = useNavigate();
    const and = " & ";
    const isMobile = useMediaQuery("(max-width: 600px)");





    const CloverWhiteTextTypography = withStyles({
        root: isMobile ? {
            fontSize: '1.5em',
            fontWeight: 'bold',
            color: "#FFFFFF",
        }
            : {
                fontSize: '3em',
                fontWeight: 'bold',
                color: "#FFFFFF",
            }
    })(Typography);



    const LoignWhiteTextTypography = withStyles({
        root: {
            fontSize: '0.9rem',
            color: "#FFFFFF",
            fontWeight: 'bold',
        }
    })(Typography);


    const WhiteTextTypography = withStyles({
        root: isMobile ? {
            fontSize: '1em',
            fontWeight: 'bold',
            color: "#FFFFFF",
        }
            : {
                fontSize: '1.5em',
                fontWeight: 'bold',
                color: "#FFFFFF",
            }
    })(Typography);

    const LoignWhiteTextTypographyMobile = withStyles({
        root: {
            fontSize: '0.7rem',
            color: "#FFFFFF",
            fontWeight: 'bold',
        }
    })(Typography);

    // const isMobile = useMediaQuery("(max-width: 600px)");
    const isMiniMobile = useMediaQuery("(max-width: 300px)");
    const isSm = useMediaQuery("(max-width: 960px)");
    // const isEight = useMediaQuery("(max-width: 800px)");
    // const isMD = useMediaQuery("(max-width: 1280px)");
    // const isXL = useMediaQuery("(max-width: 1980px)");
    const member_no = loginStore?.loginState?.member_no;
    const isMainPage = loginStore?.isMainPage;
    const isRecommenderPage = loginStore.isRecommenderPage;

    let Guide_clover_page_topBar_01 = loginStore?.Guide_clover_page_topBar_01; //Clover
    let Guide_clover_page_topBar_02 = StringFormat(loginStore?.Guide_clover_page_topBar_02, and); //Login & join





    return (
        <div >
            <Box sx={isMobile ?
                { display: 'flex', bgcolor: 'black', height: 'auto', maxWidth: '100%', mx: 'auto', minWidth: "full", py: "3%" } //Mobile Size
                : { display: 'flex', bgcolor: 'black', height: 'auto', maxWidth: '100%', mx: 'auto', }// PC Size
            }>
                <Grid container item xs={12} sm={12} md={12} justifyContent='space-between' alignItems='center'>
                    <Grid container item
                        xs={isRecommenderPage !== false ? 6 : 9} sm={isRecommenderPage !== false ? 7 : 10} md={isRecommenderPage !== false ? 7 : 10}
                        gap={2}
                    >
                        <Grid container item xs={2} sm={2} md={1} >
                            <img src={CloverleafImage} style={isMobile ? { width: '35px', height: '35px' } : { width: '70px', height: '70px' }} alt="CloverleafImage" />
                            {/* <img style={isMobile ? {width:"45px"} : isXL ? {width:'70px',height:'70px'} : {width:'45px'}} src={CloverleafImage} alt="Cloverleaf" />  */}
                        </Grid>
                        <Grid container item xs={8} sm={9} md={10} alignItems="flex-end" >
                            <CloverWhiteTextTypography >{Guide_clover_page_topBar_01}</CloverWhiteTextTypography>
                        </Grid>
                    </Grid>
                    {/* {isRecommenderPage !== false ?
                        <Grid container item xs={1} sm={1} md={2}
                            // sx={{bgcolor: "red"}}
                            justifyContent="flex-end"
                            onClick={(e) => { loginStore.setDialogOpen("CoinExchangePropose") }}
                        >
                            <Button
                                sx={{ border: 2, borderColor: "white", borderRadius: 10, fontSize: "0.5rem" }}>
                                <WhiteTextTypography>
                                    Exchange
                                </WhiteTextTypography>
                            </Button>
                        </Grid>
                        :
                        <div>

                        </div>
                    } */}
                    {isRecommenderPage !== false ?
                        <Grid container item xs={2} sm={1} md={1}
                            sx={isMobile ?{ marginLeft: "0.4rem"} : {}}
                            justifyContent="flex-end"
                            onClick={(e) => { loginStore.setDialogOpen("CloverMarket") }}
                        >
                            <Button sx={{ border: 2, borderColor: "white", borderRadius: 10, fontSize: "0.5rem" }}>
                            <WhiteTextTypography>
                                Market
                            </WhiteTextTypography>
                            </Button>
                        </Grid>
                        :
                        <div>

                        </div>
                    }
                    {isMainPage !== false ?
                        (<Grid container item xs={3} sm={2} md={2} marginRight={isSm ? "-2%" : "-4%"} direction="column" justifyContent="center" alignItems="center"
                        // onClick={(e) => { loginStore.logOut(member_no) }} 
                        >
                            <FontAwesomeIcon border icon={faArrowRightFromBracket} color='White' style={{ borderRadius: "50%" }} size={isMobile ? "xl" : "2x"}
                                onClick={(e) => { loginStore.logOut(member_no) }}
                            />
                        </Grid>)
                        :
                        (<Grid container item xs={3} sm={2} md={2} marginRight={isSm ? "-2%" : "-4%"} direction="column" justifyContent="center" alignItems="center" onClick={(e) => { navigate('login'); }} >
                            <img style={{ width: '40px' }} src={LoginButtonImage} alt="LoginButtonImage" />
                            {isMiniMobile ? "" :
                                isMobile ?
                                    <LoignWhiteTextTypographyMobile >{Guide_clover_page_topBar_02}</LoignWhiteTextTypographyMobile>
                                    :
                                    <LoignWhiteTextTypography >{Guide_clover_page_topBar_02}</LoignWhiteTextTypography>
                            }
                        </Grid>)
                    }
                </Grid>
            </Box>
        </div>
    )
}

export default observer(TopBar);